import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url = `${SERVICEBASEURL.USER}/IdentityProvider/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	name: string;
	clientId: string;
	clientAuthenticationRequired: boolean;
	openIdConnectDiscoveryUrl: string;
	propagateLogout: boolean;
	useRefreshTokenForLogout: boolean;
	mapRoles: boolean;
	roleJsonPath: string;
	iconSvg: IconSvg | null;
	sortOrder: number;
};

export type IconSvg = {
	id: string;
	url: string;
	availableSizes: number[];
};

export const defaultResponseData = (): ResponseData => {
	return {
		id: '',
		name: '',
		clientId: '',
		clientAuthenticationRequired: false,
		openIdConnectDiscoveryUrl: '',
		propagateLogout: false,
		useRefreshTokenForLogout: false,
		mapRoles: false,
		roleJsonPath: '',
		iconSvg: null,
		sortOrder: 0,
	};
};
